module.exports = __webpack_public_path__ + "img/xiebutou.4780979f.png";